import { graphql } from '@/graphql-setup'

export const COMPANY_WORK_INFRINGEMENT_SETTINGS_QUERY = graphql(`
  query CompanyWorkInfringementSettings {
    companyWorkInfringementSettings {
      id
      generationEnabled
      referencePeriodWeeks
      maxDailyWorkHours
      nightRuleEnabled
      nightDailyLimitHours
      nightWindowStart
      nightWindowEnd
      maxWeeklyWorkHours
      maxAverageWeeklyWorkHours
      weeklyOrdinaryHours
      annualOvertimeLimitHours
    }
  }
`)

export const PATCH_COMPANY_WORK_INFRINGEMENT_SETTINGS = graphql(`
  mutation PatchCompanyWorkInfringementSettings(
    $generationEnabled: Boolean
    $referencePeriodWeeks: Int
    $maxDailyWorkHours: Float
    $nightRuleEnabled: Boolean
    $nightDailyLimitHours: Float
    $nightWindowStart: Time
    $nightWindowEnd: Time
    $maxWeeklyWorkHours: Float
    $maxAverageWeeklyWorkHours: Float
    $weeklyOrdinaryHours: Float
    $annualOvertimeLimitHours: Float
  ) {
    patchCompanyWorkInfringementSettings(
      generationEnabled: $generationEnabled
      referencePeriodWeeks: $referencePeriodWeeks
      maxDailyWorkHours: $maxDailyWorkHours
      nightRuleEnabled: $nightRuleEnabled
      nightDailyLimitHours: $nightDailyLimitHours
      nightWindowStart: $nightWindowStart
      nightWindowEnd: $nightWindowEnd
      maxWeeklyWorkHours: $maxWeeklyWorkHours
      maxAverageWeeklyWorkHours: $maxAverageWeeklyWorkHours
      weeklyOrdinaryHours: $weeklyOrdinaryHours
      annualOvertimeLimitHours: $annualOvertimeLimitHours
    ) {
      settings {
        id
        generationEnabled
        referencePeriodWeeks
        maxDailyWorkHours
        nightRuleEnabled
        nightDailyLimitHours
        nightWindowStart
        nightWindowEnd
        maxWeeklyWorkHours
        maxAverageWeeklyWorkHours
        weeklyOrdinaryHours
        annualOvertimeLimitHours
      }
    }
  }
`)

export const COMPANY_USER_WORK_INFRINGEMENT_SETTINGS_QUERY = graphql(`
  query CompanyUserWorkInfringementSettings($userId: ID!) {
    resolvedWorkInfringementParams(userId: $userId) {
      referencePeriodWeeks
      maxDailyWorkHours
      nightRuleEnabled
      nightDailyLimitHours
      nightWindowStart
      nightWindowEnd
      maxWeeklyWorkHours
      maxAverageWeeklyWorkHours
      weeklyOrdinaryHours
      annualOvertimeLimitHours
    }
    companyUserWorkInfringementSettings(userId: $userId) {
      id
      referencePeriodWeeks
      maxDailyWorkHours
      nightRuleEnabled
      nightDailyLimitHours
      nightWindowStart
      nightWindowEnd
      maxWeeklyWorkHours
      maxAverageWeeklyWorkHours
      weeklyOrdinaryHours
      annualOvertimeLimitHours
    }
  }
`)

export const PATCH_COMPANY_USER_WORK_INFRINGEMENT_SETTINGS = graphql(`
  mutation PatchCompanyUserWorkInfringementSettings(
    $userId: ID!
    $referencePeriodWeeks: Int
    $maxDailyWorkHours: Float
    $nightRuleEnabled: Boolean
    $nightDailyLimitHours: Float
    $nightWindowStart: Time
    $nightWindowEnd: Time
    $maxWeeklyWorkHours: Float
    $maxAverageWeeklyWorkHours: Float
    $weeklyOrdinaryHours: Float
    $annualOvertimeLimitHours: Float
  ) {
    patchCompanyUserWorkInfringementSettings(
      userId: $userId
      referencePeriodWeeks: $referencePeriodWeeks
      maxDailyWorkHours: $maxDailyWorkHours
      nightRuleEnabled: $nightRuleEnabled
      nightDailyLimitHours: $nightDailyLimitHours
      nightWindowStart: $nightWindowStart
      nightWindowEnd: $nightWindowEnd
      maxWeeklyWorkHours: $maxWeeklyWorkHours
      maxAverageWeeklyWorkHours: $maxAverageWeeklyWorkHours
      weeklyOrdinaryHours: $weeklyOrdinaryHours
      annualOvertimeLimitHours: $annualOvertimeLimitHours
    ) {
      settings {
        id
        referencePeriodWeeks
        maxDailyWorkHours
        nightRuleEnabled
        nightDailyLimitHours
        nightWindowStart
        nightWindowEnd
        maxWeeklyWorkHours
        maxAverageWeeklyWorkHours
        weeklyOrdinaryHours
        annualOvertimeLimitHours
      }
    }
  }
`)
